import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartComponent } from "../../components/chart/chart.component";

import { ChartModule } from "angular-highcharts";
import { SessionsService } from '../sessions.service';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@NgModule({
    imports: [
    CommonModule,
    ChartModule,
    ReactiveFormsModule,
    MatChipsModule,
    ChartComponent
],
    exports: [
        ChartComponent
    ],
    providers: [
        SessionsService,
        { provide: MAT_DIALOG_DATA, useValue: {} },
        { provide: MatDialogRef, useValue: {} }
    ]
})
export class SessionModule {
}
